export default __webpack_public_path__ + "static/media/apvs-material-8.4e90ae4f.webp";